// extracted by mini-css-extract-plugin
module.exports = {"notfound":"NotFound_notfound__IlQfb","backHome":"NotFound_backHome__2efHM"};